import invariant from 'tiny-invariant';
/**
 * A currency is any fungible financial instrument, including Ether, all ERC20 tokens, and other chain-native currencies
 */
export class Currency {
    /**
     * Constructs an instance of the abstract class `Currency`.
     * @param chainId the chain ID on which this currency resides
     * @param decimals decimals of the currency
     * @param symbol symbol of the currency
     * @param name of the currency
     * @param rebase of the currency
     * @param logoUrl a link to the logo of the currency
     * @param approved if the currency is approved
     */
    constructor({ chainId: _chainId, decimals: _decimals, symbol, name, logoUrl, approved, }) {
        const chainId = Number(_chainId);
        const decimals = Number(_decimals);
        invariant(Number.isSafeInteger(chainId), 'CHAIN_ID');
        invariant(decimals >= 0 && decimals < 255 && Number.isInteger(decimals), 'DECIMALS');
        this.chainId = chainId;
        this.decimals = decimals;
        this.symbol = symbol;
        this.name = name;
        this.logoUrl = logoUrl;
        this.approved = approved;
    }
}
//# sourceMappingURL=currency.js.map